export { NavItem, default } from './nav-item';
export type { NavItemProps } from './nav-item.types';
